<template>
	<div class="mb-4">
		<Error404></Error404>
	</div>
</template>

<script>
import Error404 from '@/components/Widgets/Errors/Error404.vue';
export default {
	name: '404',
	components: {
    Error404,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
